import React from "react";
import { connect } from "react-redux";
import PageHeaderWrapper from "../../components/PageHeaderWrapper";
import { Card, Form, Drawer, Row, Col, Button, notification, Select } from "antd";
import { TableComp } from "sz-react-utils";
import _ from 'lodash';
import { FormUtils as GetAllFormFields } from 'sz-react-utils'
import Request, { API_URL, LAPI_URL } from "../../request";
import moment from "moment";
import { RightsWrapper } from "../../components/_utils/utils";
const dateFormat = localStorage.getItem('company-details') ? JSON.parse(localStorage.getItem('company-details')).dateFormat : "DD.MM.YYYY"
const localUser = localStorage.getItem('user') ? JSON.parse(localStorage.getItem('user')) : {}

const { Option } = Select;

@Form.create()

class AddApologyDrawer extends React.Component {
    state = {
        visible: true
    }

    onClose = () => {
        setTimeout(() => {
            this.props.onClose()
        }, 50)
    }


    componentDidMount() {
        let { record } = this.props;
        if (record) {
            setTimeout(() => {
                this.props.form.setFieldsValue({
                    title: record.title,
                    explanation: record.explanation
                })
            }, 50)
        }
    }

    handleSubmit = (e) => {
        e.preventDefault();
        let { form } = this.props;
        form.validateFieldsAndScroll(async (err, valData) => {
            let { record } = this.props;
            let values = _.clone(valData);
            let response;
            if (record && record._id) {
                values._id = record._id;
                response = await Request.updateApology(values);
            } else {
                response = await Request.addApology(values);
            }

            if (response.success) {
                notification.success({
                    message: response.message
                })
            } else {
                notification.error({
                    message: response.message
                })
            }
            this.onClose()
        })
    }


    render() {
        let { visible } = this.state;
        let { form: { getFieldDecorator, setFieldsValue } } = this.props;
        let inputTypes = {
            fields: [
                {
                    label: 'Apology Subject',
                    key: 'title',
                    placeholder: 'Enter a brief title (e.g., Late Arrival, Missed Meeting)',
                    required: true
                },
                {
                    label: 'Detailed Explanation',
                    key: 'explanation',
                    placeholder: 'Describe the reason and circumstances for the apology',
                    required: true,
                    type: 'textarea'
                }
            ]
        }
        let { record } = this.props;
        return (

            <Drawer
                title={record && record._id ? 'Edit Apology' : "Add Apology "}
                placement="right"
                closable={true}
                onClose={this.onClose}
                visible={visible}
                width={600}>
                <Card bordered={true}>
                    <Form onSubmit={this.handleSubmit}>
                        <GetAllFormFields inputSchema={inputTypes} getFieldDecorator={getFieldDecorator} apiurl={API_URL} />
                        <Row style={{ marginTop: '20px' }}>
                            <Col span={8} />
                            <Col span={8}>
                                <Button
                                    type="primary"
                                    htmlType="submit"
                                    style={{ marginBottom: 10 }}
                                    loading={this.props.loading}>
                                    Save
                                </Button>
                            </Col>
                            <Col span={8} />
                        </Row>
                    </Form>
                </Card>
            </Drawer>
        )
    }
}

class StaffAppologies extends React.Component {
    state = {
        count: 0,
        showDrawer: false,
        users: [],
        userId: null,
        branchs: [],
        record: {},
    }


    constructor(props) {
        super(props);
        this.table = React.createRef();
    }

    loadUser = async () => {
        let params = {
            sortField: "_id",
            sortOrder: "ascend",
            results: 200,
            active: true,
            userType: { $ne: "Student" },
            userBranch: localUser.userBranch,
        };
        let response = await Request.loadUser({
            ...params,
            regExFilters: ["name"],
        });
        response.data = response.data.reduce((temp, vv) => {
            temp.push({ _id: vv._id, display: vv.name })
            return temp
        }, []);
        this.setState({ users: response.data });
    }

    loadBranches = async () => {
        let params = {
            sortField: 'branchName',
            sortOrder: 'ascend',
            results: 1000,
            count: 1000,
            status: true
        }
        Request.loadBranch({ ...params })
            .then(resp => {
                resp.data = resp.data.reduce((temp, vv) => {
                    temp.push({ value: vv._id, text: vv.branchName })
                    return temp
                }, [])
                this.setState({ branchs: resp.data });
            })
            .catch(err => {
                console.log(err)
            })
    }

    componentDidMount() {
        this.loadUser();
        this.loadBranches()
    }

    apiRequest = (params) => {
        return new Promise(async (resolve) => {
            if (this.state.userId) {
                params.userId = this.state.userId
            }
            let response = await Request.getApologies(params);
            this.setState({ count: response.total });
            resolve(response);
        })
    }

    showApologyDrawer = () => {
        this.setState({ showDrawer: true });
    }

    closeApologyDrawer = () => {
        this.setState({
            showDrawer: false
        }, () => {
            this.table.current.reload();
        })
    }


    render() {
        let { count, showDrawer, users, record } = this.state;
        const columns = [
            {
                title: "Sr.No",
                key: 'serialNumber',
                width: 50,
                render: (text, record, index) => (
                    <div>{index + 1}</div>
                )
            },
            {
                title: 'Added Date',
                key: "addedDate",
                searchTextName: `${dateFormat}`,
                render: (text, record) => (
                    <div>{record.addedDate ? moment(record.addedDate).format(dateFormat) : null}</div>
                )
            },
            {
                title: 'Name',
                key: "username",
                dataIndex: 'userId.name',
                searchTextName: 'name'
            },
            {
                title: 'Branch',
                key: 'branchId',
                dataIndex: 'branchId.branchName',
                filters: this.state.branchs
            },
            {
                title: 'Apology Subject',
                key: "title",
                searchTextName: 'Apology Subject'
            },
            {
                title: 'Detailed Explanation',
                key: "explanation",
                searchTextName: 'Explanation',
            },
            {
                title: 'Action',
                key: 'operation',
                render: (text, record) => (
                    <React.Fragment>
                        <Button icon="edit" shape="circle" onClick={() => this.setState({ showDrawer: true, record: record })} />
                    </React.Fragment>
                )
            }

        ];
        return (
            <PageHeaderWrapper title={`Apologies - ${count}`}>
                {
                    showDrawer ?
                        <AddApologyDrawer onClose={this.closeApologyDrawer} record={record} />

                        : null
                }
                <Card bordered={true}>
                    <Row gutter={16}>
                        <Col span={6}>
                            <label>Search by User</label>
                            <Select
                                allowClear
                                showSearch
                                style={{ width: '100%' }}
                                value={this.state.userId}
                                placeholder="Select User"
                                onChange={userId => {
                                    this.setState({ userId: userId && userId.toString() }, () => {
                                        setTimeout(() => {
                                            this.table.current.reload();
                                        }, 50);
                                    });
                                }}
                            >
                                {users.map((val, idn) => (
                                    <Option key={val._id} value={val._id}>
                                        {val.display}
                                    </Option>
                                ))}
                            </Select>
                        </Col>

                        <Col span={4}>
                            <RightsWrapper myRight={"apology.view"}>
                                <Button type="primary" onClick={this.showApologyDrawer}>
                                    Add
                                </Button>
                            </RightsWrapper>
                        </Col>
                    </Row>
                </Card>
                <Card bordered={true}>
                    <TableComp
                        ref={this.table}
                        columns={columns}
                        apiRequest={this.apiRequest}
                        extraProps={{ scroll: { x: 900 } }}
                        pagination={{
                            showSizeChanger: true,
                            defaultPageSize: '20',
                            pageSizeOptions: ['10', '20', '50', '100', '1000']
                        }}
                    />
                </Card>

            </PageHeaderWrapper >
        )
    }
}



const mapStateToProps = ({ global, router }) => ({
    loading: global.buttonLoading,
    categories: global.categories,
    search: router.location.search,
    pathname: router.location.pathname,
});

const mapDispatchToProps = (dispatch) => {
    return {
        dispatch,
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(StaffAppologies);